// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_0cb770', '__Roboto_Fallback_0cb770'","fontStyle":"normal"},"className":"__className_0cb770","variable":"__variable_0cb770"};